import Date_ from './Date_'

export default class BeforeOrEqual extends Date_ {
  get ruleName () {
    return 'beforeOrEqual'
  }

  passes () {
    return this.momentFormat(this.value).isSameOrBefore(this.momentFormat(this.date), 'd')
  }
}
